import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { createContext } from 'react'

export const TodoContext=createContext()

export const TodoProvider=(props)=>{
    const[todo,setTodo]=useState([])
    
    useEffect(()=>{
        const list=JSON.parse(localStorage.getItem("todos"))
        if(list){
        console.log(list)
            setTodo(list)
        }
    },[])
    useEffect(()=>{
        localStorage.setItem("todos",JSON.stringify(todo))  
        console.log("Item set")
      },[todo])
    return(
        <TodoContext.Provider value={[todo,setTodo]}>
{props.children}
        </TodoContext.Provider>
    )
}